import {ENDPOINT_ADMIN_ORACLES_LIST} from "../../constants/api";

const CancelablePromise = require('mn-utils/CancelablePromise');
const Emitter = require('mn-utils/Emitter');
const {
  apiRequest,
} = require('../ws');


const mockOracles$ = new Emitter([
  {
    id: 'ethereum',
    name: 'Ethereum',
    checked: 1,
    time: '2 sec',
  },
  {
    id: 'bitcoin',
    name: 'Bitcoin',
    checked: 1,
    time: '1 sec',
  },
  {
    id: 'bitcoin-lighting',
    name: 'Bitcoin Lighting',
    checked: 1,
    time: '2 sec',
  },
  {
    id: 'litecoin',
    name: 'Litecoin',
    checked: 1,
    time: '2 sec',
  },
  {
    id: 'dash',
    name: 'Dash',
    checked: 1,
    time: '1 sec',
  },
  {
    id: 'bitcoin-cash',
    name: 'Bitcoin Cash',
    checked: 1,
    time: '2 sec',
  },
  {
    id: 'ripple',
    name: 'Ripple',
    checked: 1,
    time: '2 sec',
  },
]);


export function apiAdminOraclesList() {
  if (process.env.MOCK || 1) {
    return CancelablePromise.delay(500, {
      list: mockOracles$.getValue(),
    });
  }
  return apiRequest(ENDPOINT_ADMIN_ORACLES_LIST);
}
